import React from 'react';
import Image from 'react-bootstrap/Image';
import { PropTypes } from 'prop-types';
import { Row } from 'react-bootstrap';
import { strings } from '../../assets/strings/all';

const getStatusMessage = (slug) => {
  const { cases } = strings;

  switch (slug) {
    case 'screening':
      return cases.status_messages.screening;
    case 'draft':
      return cases.status_messages.draft;
    case 'open':
      return cases.status_messages.open;
    case 'close':
      return cases.status_messages.close;
    case 'returned':
      return cases.status_messages.returned;
    default:
      return '-';
  }
};
const getStatusColor = (slug) => {
  switch (slug) {
    case 'screening':
      return 'darkcyan';
    case 'draft':
      return '';
    case 'open':
      return '#005587';
    case 'close':
      return 'teal';
    case 'returned':
      return 'red';
    default:
      return '-';
  }
};

function HsCaseStatusIcon(props) {
  const { caseStatus = { slug: '' }, loading } = props;
  const { iconClass } = caseStatus;

  return loading ? (
    <span className="case-status-loader shimmer-loader"></span>
  ) : (
    <Row
      className="px-2"
      style={{
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      <Image width={25} fluid {...props} src={iconClass} />
      <div
        style={{
          color: getStatusColor(caseStatus.slug),
          fontWeight: 'bold',
        }}
      >
        {getStatusMessage(caseStatus.slug)}
      </div>
    </Row>
  );
}
HsCaseStatusIcon.propTypes = {
  caseStatus: PropTypes.object,
};

export default HsCaseStatusIcon;
